import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import * as _ from 'lodash';
import { User } from '../models/user';
import { HttpService } from '../../../../../services/http.service';
import { Customer } from "../../customers/models/customer";
import { LocationTree } from '../../../../shared/components/location-hierarchy/models/location-tree';
import { Constants } from '../../../../../app.constant';
@Injectable()
export class UserService extends HttpService {
  public user: User;
  public editdata: User = <User>{};

  getUsers(): Observable<User[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/user', requestOptionsArgs, 'users')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  getUsersByPOC(customerId:string): Observable<User[]> {
    // get users from api
    /*let param = {
      customerId:customerId
    }
    let requestOptionsArgs = { search: param };*/
    let token = Constants.userAuthorisedToken();
    let head = { 'Content-Type': 'application/json' };
    if (token) {
      head['Authorization'] = `Bearer ${token}`;

    }
    if (customerId) {
      head['customerId'] = customerId;
    }
    let headers = new Headers(head);
    var requestOptionsArgs = new RequestOptions({ headers: headers });
    return this.getApi('/user',requestOptionsArgs, 'users')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
  
  getUsersForAdvanceSearch(customerId: string): Observable<User[]> {
    var requestOptionsArgs = {};
    return this.getApi('/user-filter-for-advance-search', requestOptionsArgs, 'users')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  addUser(user: object): Observable<boolean> {
    user = _.assignIn({}, user);
    let requestOptionsArgs = { body: user };
    return this.postApi('/user', requestOptionsArgs, 'register')
      .map(res => <User>res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  editUser(userId: string, user: object): Observable<boolean> {
    user = _.assignIn({}, user);
    let requestOptionsArgs = { body: user };
    return this.putApi('/user/' + userId, requestOptionsArgs, 'register')
      .map(res => {
        let user = <User>res.json() && res.json().user;
        this.user = user;
        return true;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  resetEditUser() {
    this.editdata = <User>{};
  }

  deleteUser(userIds: any): Observable<boolean> {
    let requestOptionsArgs = new RequestOptions({ body: { 'ids': userIds } });
    return this.deleteApi('/user', requestOptionsArgs, 'deleteUser')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getRoles(): Observable<User[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/role', requestOptionsArgs, 'roles')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  updateStatus(param): Observable<boolean> {
    let requestOptionsArgs = { body: param };
    return this.putApi('/user', requestOptionsArgs, 'customer')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getLocationHierarchy() {
    let requestOptionsArgs = {};
    return this.getApi('/location-hierarchy', requestOptionsArgs, 'location-hierarchy')
      .map(res => <LocationTree>res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getRoleById(roleId:String): Observable<User[]> {
    // get users from api
    let requestOptionsArgs = {};
    return this.getApi('/role/'+roleId, requestOptionsArgs, 'roles')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getLocationById(locationId){
    let requestOptionsArgs = {};
    return this.getApi('/location-hierarchy/'+locationId, requestOptionsArgs, 'location-hierarchy')
      .map(res => <LocationTree>res.json().result)
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getUsersByAdvanceSearch(searchParam): Observable<User[]> {
    // get users from api
    const optionals = Constants.setParamsObject(searchParam);
    let searchQuery:any;
    let query=optionals.split('=')
    if(query[1]!='%7B%7D'){
      searchQuery=optionals;
    }else{
      searchQuery='';
    }
    let requestOptionsArgs = { };
    return this.getApi('/user'+searchQuery, requestOptionsArgs, 'users')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

}


// customer Id in header
/* let token = Constants.userAuthorisedToken();
    let custId = Constants.CurrentCustomerInfomations(customerId);
    let head = { 'Content-Type': 'application/json' };
    if (token) {
      head['Authorization'] = `Bearer ${token}`;
      
    }
    if (customerId) {
      head['customerId'] = customerId;
    }
    let headers = new Headers(head);
    var options = new RequestOptions({ headers: headers });*/


// WEBPACK FOOTER //
// ./src/app/pages/admin/components/users/services/user.service.ts